module.exports = __webpack_public_path__ + "static/media/thalalcassim.aec1b708.jpeg";